import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { createCustomElement } from "@angular/elements";
import { UserLoginNavbarComponentGeneric } from "./user-login.component";
import { MainHeaderUserDetailsNavbarModuleGeneric } from "../user-details/navbar-side/navbar-side.module";
import { UserLoginButtonModuleGeneric } from "../login-button/login-button.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MainHeaderUserDetailsNavbarModuleGeneric,
        UserLoginButtonModuleGeneric
    ],
    declarations: [UserLoginNavbarComponentGeneric],
    exports: [UserLoginNavbarComponentGeneric]
})
/**
 * @extends UserLoginModuleGeneric
 */
export class UserLoginNavbarComponentModuleGeneric {
    constructor(private injector: Injector) {
        const UserLoginNavbar = createCustomElement(UserLoginNavbarComponentGeneric, {injector});
        !customElements.get('ngx-user-login') && customElements.define('ngx-user-login', UserLoginNavbar);
    }
}


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MainHeaderUserDetailsNavbarModuleGeneric,
        UserLoginNavbarComponentModuleGeneric,
        UserLoginButtonModuleGeneric
    ]
})
export class UserLoginNavbarModuleGeneric {}
